import DeliveryAddressPicker from 'client/delivery_address/DeliveryAddressPicker'
import IInput from 'components/generated_form/IInput'
import { pythonDateToString } from 'DatetimeUtils'
import { ICartOrder } from 'order_components/IOrder'
import OfficeSelect from 'office/OfficeSelect'
import SelectDelivType from 'select_with_global_state/SelectDelivType'

function getCommonFields(order: ICartOrder, showExtraPhone: boolean): IInput[] {
  const inputs: IInput[] = [
    {
      id: 'receive_id',
      type: 'component',
      title: 'Способ доставки',
      defaultValue: order.receive_id,
      component: (onChange, onEntered, defaultValue) => (
        <SelectDelivType
          // itemId={parseInt(defaultValue?.toString() || '') || null}
          defaultItemId={parseInt(defaultValue?.toString() || '') || null}
          onSelect={onEntered}
        />
      ),
    },
  ]

  if (showExtraPhone) {
    inputs.push({
      id: 'extra_phone_number',
      type: 'phone',
      title: 'Дополнительный номер телефона',
      defaultValue: order.extra_phone_number,
      otherProps: { style: { maxWidth: '230px' } },
    })
  }

  inputs.push({
    id: 'comments',
    type: 'multiline',
    title: 'Дополнительная информация',
    defaultValue: order.comments,
    otherProps: { maxLength: 200 },
  })
  return inputs
}

export function getOrderInfoFormFields(
  order: ICartOrder,
  showExtraPhone: boolean
): IInput[] {
  let inputs = getCommonFields(order, showExtraPhone)

  inputs.splice(1, 0, {
    id: 'office_id',
    type: 'component',
    title: 'Офис выдачи',
    defaultValue: order.office_id,
    component: (onChange, onEntered, defaultValue) => (
      <OfficeSelect
        defaultItemId={parseInt(defaultValue?.toString() || '') || null}
        onSelect={onEntered}
      />
    ),
  })

  return inputs
}

export function getOrderInfoFormFieldsWithDelivery(
  order: ICartOrder,
  showExtraPhone: boolean,
  startTimeMaxValue: string,
  endTimeMinValue: string
): IInput[] {
  const inputs: IInput[] = [
    {
      id: 'desired_date',
      type: 'date',
      title: 'Желаемая дата доставки',
      defaultValue: pythonDateToString(order.desired_date),
    },
    {
      id: 'desired_start_time',
      type: 'time',
      title: 'С',
      defaultValue: order.desired_start_time,
      otherProps: { minValue: '8:00', maxValue: startTimeMaxValue },
    },
    {
      id: 'desired_end_time',
      type: 'time',
      title: 'До',
      defaultValue: order.desired_end_time,
      otherProps: { minValue: endTimeMinValue, maxValue: '17:00' },
    },
    {
      id: 'deliv_addr_id',
      type: 'component',
      title: 'Адрес',
      defaultValue: order.deliv_addr_id,
      component: (onChange, onEntered, defaultValue) => (
        <DeliveryAddressPicker
          onSelect={onEntered}
          defaultValue={
            typeof defaultValue === 'string'
              ? parseInt(defaultValue) || null
              : defaultValue || null
          }
        />
      ),
    },
    ...getCommonFields(order, showExtraPhone),
  ]

  return inputs
}
